import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import CloseXSvg from '../other/svg/CloseXSvg'

interface Props {
  isOpen?: boolean
  onClose?: () => void
}

const ChangeRequestWaitingModal = ({ isOpen = true, onClose }: Props): JSX.Element => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(isOpen)

  useEffect(() => {
    setIsModalOpen(isOpen)
  }, [isOpen])

  const handleClose = (): void => {
    setIsModalOpen(false)
    onClose?.()
  }

  if (!isModalOpen) {
    return <></>
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-groupBlue bg-opacity-20">
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={handleClose} />
      <div className="relative bg-white rounded-4 shadow-bothLarge p-6 max-w-md w-full mx-4">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-2 hover:bg-lightGrey rounded-2 transition-colors">
          <CloseXSvg className="w-5 h-5 text-grey" />
        </button>

        <div className="text-center pt-4">
          <div
            style={{ borderRadius: '100%' }}
            className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-successGreen">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          <h3 className="text-xl font-SemiBold text-darkGrey mb-3">{t('change_request_modal.title')}</h3>

          <p className="text-grey mb-6 leading-relaxed">{t('change_request_modal.message')}</p>

          <button
            onClick={handleClose}
            className="bg-groupBlue text-white px-6 py-3 rounded-2 hover:bg-darkBlue transition-colors font-Medium">
            {t('change_request_modal.got_it')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ChangeRequestWaitingModal
